module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAj0lEQVQ4y2NgGBSgdNXt/+TgQWTAfyzg37+//399eQfEb8FsbACnAf/+/vn/6eHp/08PTvz/dH///4/3T/z/9+c38Qb8+vwaqHnS/6dL7YHY9v+TfT3/f358SbwBPz+9Atrc+//5Mjsgtvn/ZE/H/x8fn5HmhY/3T/5/srfn/+Pd7f8/3D2K3wvDIB0MbQAAi8IC3+UbBgkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/AR.png
// module id = 1077
// module chunks = 0